import './report-item.scss';
import React, { useMemo } from 'react';

import { ReportPreferences } from 'src/dtos/user-preferences.dto';
import { keyboardClickable } from 'src/utils/a11y-utils';
interface ReportItemProps {
    reportData: ReportPreferences;
    selectReport: (reportType: string) => void;
    isSelected: boolean;
}

export const ReportItem: React.FC<ReportItemProps> = ({reportData, selectReport, isSelected}) => {

    const reportClassName = useMemo(() =>
        `${reportData.reportName.toLowerCase().replaceAll(' ', '-')} ${isSelected ? 'selected' : ''}`
    , [reportData, isSelected]);

    return <div className={`report-item ${reportClassName}`} data-testid="report-item" {...keyboardClickable(() => selectReport(reportData.reportName))}>
        <div className="header-report-item">
            {reportData.reportName}
        </div>
    </div>;
};
